{
  "v4.documents2.annuler": "Annuler",
  "v4.documents2.aucun_resultat_filtre": "Aucun résultat pour ce filtre.",
  "v4.documents2.code.AI_KILL_SWITCH_ACTIVE": "L’IA est arrêtée : réessayez quand elle sera rétablie.",
  "v4.documents2.code.AMONT_PORTE_DEJA_DECIDEE": "Cette porte est déjà décidée.",
  "v4.documents2.code.AMONT_PRODUCTION_INCONNUE": "Cette production n’est pas définie par le modèle du projet.",
  "v4.documents2.code.AMONT_SOURCE_NON_APPROUVEE": "La source doit être une version approuvée.",
  "v4.documents2.code.CORE_UNAVAILABLE": "L’IA est arrêtée : réessayez quand elle sera rétablie.",
  "v4.documents2.code.CREATEUR_N_APPROUVE_PAS": "L’auteur ne décide pas de sa propre demande.",
  "v4.documents2.code.DROIT_NON_TENU": "Vous n’avez pas le droit requis pour ce geste.",
  "v4.documents2.code.NOT_FOUND": "Objet introuvable.",
  "v4.documents2.code.SOD_VIOLATION": "Le créateur du run ne décide pas de sa porte.",
  "v4.documents2.code.SPEC_CHANGE_SELF_DECISION": "L’auteur ne décide pas de sa propre demande.",
  "v4.documents2.code.VALIDATION_ERROR": "Saisie refusée par le serveur.",
  "v4.documents2.code.VALIDATION_PAR_UN_TIERS": "Une autre personne doit valider.",
  "v4.documents2.code.VERSION_CONFLICT": "L’objet a changé depuis votre lecture : relisez-le.",
  "v4.documents2.code.WAIVER_DUPLICATE": "Une dérogation est déjà ouverte sur ce critère.",
  "v4.documents2.code_historique": "Code historique : {{code}}",
  "v4.documents2.couverture": "Couverture",
  "v4.documents2.derogation.aucune_decision_locale": "La demande part au circuit de décision : rien n’est décidé ici.",
  "v4.documents2.derogation.choisir_porteur": "Choisir un membre",
  "v4.documents2.derogation.cible": "Cible de la dérogation",
  "v4.documents2.derogation.cible_hors_projet": "Cette cible n’appartient pas au projet.",
  "v4.documents2.derogation.cible_test_usage": "Test d’usage {{cible}}",
  "v4.documents2.derogation.demande": "Demande",
  "v4.documents2.derogation.echeance": "Échéance",
  "v4.documents2.derogation.echeance_future": "L’échéance doit être future.",
  "v4.documents2.derogation.echeance_requise": "L’échéance est obligatoire pour un critère.",
  "v4.documents2.derogation.echec": "L’envoi a échoué.",
  "v4.documents2.derogation.enonce": "Énoncé",
  "v4.documents2.derogation.envoyee": "Demande envoyée (dérogation {{id}}).",
  "v4.documents2.derogation.envoyer": "Envoyer la demande",
  "v4.documents2.derogation.justification": "Justification",
  "v4.documents2.derogation.justification_aide": "Expliquez pourquoi le critère ne peut pas être tenu (20 caractères au moins).",
  "v4.documents2.derogation.mesures": "Mesures compensatoires (une par ligne)",
  "v4.documents2.derogation.mesures_requises": "Au moins une mesure testable est requise.",
  "v4.documents2.derogation.minimum": "Au moins 20 caractères.",
  "v4.documents2.derogation.nature": "Nature",
  "v4.documents2.derogation.nature_critere": "Critère",
  "v4.documents2.derogation.nature_incompatible": "Cette nature de cible ne peut pas faire l’objet d’une dérogation.",
  "v4.documents2.derogation.niveau": "Niveau d’impact",
  "v4.documents2.derogation.niveau_high": "Élevé",
  "v4.documents2.derogation.niveau_low": "Faible",
  "v4.documents2.derogation.niveau_medium": "Moyen",
  "v4.documents2.derogation.origine": "Origine : {{origine}}",
  "v4.documents2.derogation.ouvrir": "Ouvrir la dérogation",
  "v4.documents2.derogation.porteur": "Porteur de la dérogation",
  "v4.documents2.derogation.porteur_requis": "Choisissez le porteur.",
  "v4.documents2.derogation.reference": "Référence",
  "v4.documents2.derogation.reference_version": "{{code}} (version {{version}})",
  "v4.documents2.derogation.titre": "Solliciter une dérogation",
  "v4.documents2.derogation.usage_indisponible": "La dérogation d’un test d’usage attend l’arbitrage de son circuit d’organisation.",
  "v4.documents2.ecran_non_realise": "« {{ecran}} » : cet écran n’est pas encore réalisé.",
  "v4.documents2.etat.chargement": "Chargement : {{quoi}}…",
  "v4.documents2.etat.en_cours": "En cours…",
  "v4.documents2.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v4.documents2.etat.introuvable": "Introuvable : {{quoi}}.",
  "v4.documents2.etat.reessayer": "Réessayer",
  "v4.documents2.etat.refus": "Accès refusé : {{quoi}}.",
  "v4.documents2.etat.vide": "Rien à afficher.",
  "v4.documents2.etat_document.approuve": "Approuvé",
  "v4.documents2.etat_document.brouillon": "Brouillon",
  "v4.documents2.etat_document.en_relecture": "En relecture",
  "v4.documents2.etat_document.publication_en_attente": "Publication en attente",
  "v4.documents2.etat_document.publication_en_echec": "Publication en échec",
  "v4.documents2.etat_document.publie": "Publié",
  "v4.documents2.etat_document.refuse": "Refusé",
  "v4.documents2.etat_document.remplace": "Remplacé",
  "v4.documents2.feuille.aujourd_hui": "Aujourd’hui : {{date}}",
  "v4.documents2.feuille.avancement": "Avancement : {{avancement}}",
  "v4.documents2.feuille.echeance_depassee": "Dépassé depuis le {{date}}",
  "v4.documents2.feuille.echeance_non_datee": "Non daté",
  "v4.documents2.feuille.echeance_prevue": "Prévu le {{date}}",
  "v4.documents2.feuille.elements_termines": "{{n}} élément(s) terminé(s) sur {{total}}",
  "v4.documents2.feuille.entree": "Entrée",
  "v4.documents2.feuille.etat_a_venir": "À venir",
  "v4.documents2.feuille.etat_en_cours": "En cours",
  "v4.documents2.feuille.etat_en_retard": "En retard",
  "v4.documents2.feuille.etat_livre": "Livré",
  "v4.documents2.feuille.etat_non_date": "Sans date",
  "v4.documents2.feuille.etat_termine": "Terminé, non livré",
  "v4.documents2.feuille.frise": "Frise du produit",
  "v4.documents2.feuille.legende": "Légende : livré, terminé non livré, en cours, à venir, en retard, sans date.",
  "v4.documents2.feuille.ouvrir_entree": "Ouvrir l’entrée {{reference}}",
  "v4.documents2.feuille.planifier": "Planifier les cadences",
  "v4.documents2.feuille.reperes": "Repères",
  "v4.documents2.feuille.reperes_indisponibles": "Les repères seront affichés une fois la feuille de route relue.",
  "v4.documents2.feuille.titre": "Feuille de route du produit",
  "v4.documents2.feuille.toutes_entrees": "Toutes les entrées",
  "v4.documents2.feuille.vide": "La feuille de route est vide.",
  "v4.documents2.feuille.vide_filtre": "Aucun élément pour cette entrée.",
  "v4.documents2.feuille.vide_reperes": "Aucun repère défini par le modèle.",
  "v4.documents2.modele": "Modèle figé : {{modele}}",
  "v4.documents2.modele_inconnu": "Modèle du projet inconnu.",
  "v4.documents2.ouvrir_document": "Ouvrir « {{titre}} »",
  "v4.documents2.ouvrir_fiche": "Ouvrir la fiche",
  "v4.documents2.porte.acceptee": "Porte acceptée.",
  "v4.documents2.porte.accepter": "Accepter la porte",
  "v4.documents2.porte.aucune_decision": "Aucune décision pour ce run.",
  "v4.documents2.porte.aucune_preuve": "Aucune preuve exigée pour cette porte.",
  "v4.documents2.porte.conditions": "Conditions",
  "v4.documents2.porte.createur": "Créateur du run",
  "v4.documents2.porte.decision": "Décision",
  "v4.documents2.porte.decision_acceptee": "{{nom}} a accepté l’étape {{etape}} : {{motif}}",
  "v4.documents2.porte.decision_echec": "La décision a échoué.",
  "v4.documents2.porte.decision_refusee": "{{nom}} a refusé le {{le}} : {{motif}}",
  "v4.documents2.porte.echec": "Le geste a échoué.",
  "v4.documents2.porte.etat": "État",
  "v4.documents2.porte.execution": "Exécution de l’étape {{etape}}",
  "v4.documents2.porte.historique": "Historique des décisions",
  "v4.documents2.porte.hors_projet": "Cette porte n'appartient pas au projet ouvert : aucune décision possible depuis ce projet.",
  "v4.documents2.porte.motif": "Motif de la décision",
  "v4.documents2.porte.motif_obligatoire": "Le motif est obligatoire.",
  "v4.documents2.porte.preparee": "Run lancé.",
  "v4.documents2.porte.preparer": "Préparer la porte",
  "v4.documents2.porte.preuves": "Preuves exigées",
  "v4.documents2.porte.preuves_actuelles": "Actuelles ({{n}})",
  "v4.documents2.porte.preuves_execution": "Preuves d’exécution",
  "v4.documents2.porte.preuves_manquantes": "Manquantes ({{n}})",
  "v4.documents2.porte.preuves_perimees": "Périmées ({{n}})",
  "v4.documents2.porte.preuves_relues": "J’ai relu les preuves de ce run",
  "v4.documents2.porte.quoi": "la porte",
  "v4.documents2.porte.refus_distinct": "Le refus est journalisé comme un événement distinct d’un retrait.",
  "v4.documents2.porte.refusee": "Porte refusée.",
  "v4.documents2.porte.refuser": "Refuser la porte",
  "v4.documents2.porte.reprendre": "Reprendre le run",
  "v4.documents2.porte.reprise": "Run repris.",
  "v4.documents2.porte.retour": "Retour aux portes",
  "v4.documents2.porte.run": "Run {{run}} : {{etat}}",
  "v4.documents2.porte.run_echec": "en échec",
  "v4.documents2.porte.run_en_attente_de_decision": "en attente de décision",
  "v4.documents2.porte.run_en_cours": "en cours",
  "v4.documents2.porte.run_terminee": "terminé",
  "v4.documents2.porte.titre": "Porte de phase",
  "v4.documents2.porte.version": "Version figée",
  "v4.documents2.portes.aucune": "Aucune porte prévue par ce modèle.",
  "v4.documents2.portes.conditions": "Conditions : {{conditions}}",
  "v4.documents2.portes.etat_a_preparer": "À préparer",
  "v4.documents2.portes.etat_acceptee": "Acceptée",
  "v4.documents2.portes.etat_non_atteinte": "Non atteinte",
  "v4.documents2.portes.etat_prete_a_decider": "Prête à décider",
  "v4.documents2.portes.etat_refusee": "Refusée",
  "v4.documents2.portes.filtre": "État des portes",
  "v4.documents2.portes.filtre_a_decider": "À décider",
  "v4.documents2.portes.filtre_a_preparer": "À préparer",
  "v4.documents2.portes.filtre_terminees": "Terminées",
  "v4.documents2.portes.filtre_toutes": "Toutes",
  "v4.documents2.portes.methode": "Méthode du projet",
  "v4.documents2.portes.modele": "Gabarit {{modele}}, version {{version}}",
  "v4.documents2.portes.nombre": "{{n}} porte(s) prévue(s) par le plan",
  "v4.documents2.portes.preuves_manquantes": "Preuves manquantes",
  "v4.documents2.portes.titre": "Portes de phase",
  "v4.documents2.preuve.fraiche": "Preuve fraîche",
  "v4.documents2.preuve.perimee": "Preuve périmée",
  "v4.documents2.preuve.sans": "Sans preuve",
  "v4.documents2.publies.a_publier": "Documents à publier",
  "v4.documents2.publies.colonne_code": "Référence de code",
  "v4.documents2.publies.colonne_document": "Document",
  "v4.documents2.publies.colonne_empreinte": "Empreinte de sortie",
  "v4.documents2.publies.colonne_publication": "Référence de publication",
  "v4.documents2.publies.colonne_type": "Type",
  "v4.documents2.publies.colonne_version": "Version",
  "v4.documents2.publies.croissant": "Croissant",
  "v4.documents2.publies.decisions": "Décisions en attente",
  "v4.documents2.publies.decroissant": "Décroissant",
  "v4.documents2.publies.derniere_version": "Dernière version",
  "v4.documents2.publies.incomplete": "Publication incomplète : une référence manque.",
  "v4.documents2.publies.sens": "Sens",
  "v4.documents2.publies.titre": "Documents publiés",
  "v4.documents2.publies.tous_types": "Tous les types",
  "v4.documents2.publies.toutes_versions": "Toutes les versions",
  "v4.documents2.publies.tri_document": "Document",
  "v4.documents2.publies.tri_element_source": "Élément source",
  "v4.documents2.publies.tri_empreinte": "Empreinte",
  "v4.documents2.publies.tri_reference_code": "Référence de code",
  "v4.documents2.publies.tri_reference_publication": "Référence de publication",
  "v4.documents2.publies.trier": "Trier par",
  "v4.documents2.publies.type": "Type de document",
  "v4.documents2.publies.versions": "Versions",
  "v4.documents2.publies.vide": "Aucun document publié dans ce projet.",
  "v4.documents2.raison.createur_n_approuve_pas": "L’auteur ne décide pas de sa propre demande.",
  "v4.documents2.raison.ia_arretee": "L’IA est arrêtée : réessayez quand elle sera rétablie.",
  "v4.documents2.raison.validation_par_un_tiers": "Une autre personne doit valider.",
  "v4.documents2.redaction.approbateur": "Approuvé par {{nom}}",
  "v4.documents2.redaction.aucune_production": "Aucune production documentaire dans ce modèle.",
  "v4.documents2.redaction.aucune_revision_filtre": "Aucune révision ne correspond à ce filtre.",
  "v4.documents2.redaction.decisions": "Décisions à prendre",
  "v4.documents2.redaction.deposer_entree": "Déposer une entrée",
  "v4.documents2.redaction.documents": "Documents",
  "v4.documents2.redaction.entrees": "Entrées du projet",
  "v4.documents2.redaction.filtre_preuve": "Preuve",
  "v4.documents2.redaction.filtre_preuve_perimee": "Preuve périmée",
  "v4.documents2.redaction.filtre_revision": "État de la révision",
  "v4.documents2.redaction.filtre_sans_preuve": "Sans preuve",
  "v4.documents2.redaction.filtre_toutes": "Toutes",
  "v4.documents2.redaction.liste_documents": "Documents du projet",
  "v4.documents2.redaction.onglet_documents": "Documents",
  "v4.documents2.redaction.onglet_revisions": "Révisions",
  "v4.documents2.redaction.onglets": "Rédaction",
  "v4.documents2.redaction.origine": "Origine : {{origine}}",
  "v4.documents2.redaction.points_bloquants": "{{n}} point(s) bloquant(s) non vérifié(s)",
  "v4.documents2.redaction.rediger": "Rédiger un document",
  "v4.documents2.redaction.revisions": "Révisions",
  "v4.documents2.redaction.titre": "Rédaction et révisions",
  "v4.documents2.redaction.vide_documents": "Aucun document dans ce projet.",
  "v4.documents2.redaction.vide_revisions": "Aucune révision dans ce projet.",
  "v4.documents2.rediger.amont": "Documents amont approuvés",
  "v4.documents2.rediger.approbation": "Approbation",
  "v4.documents2.rediger.approbation_absente": "Aucune approbation trouvée pour cette version.",
  "v4.documents2.rediger.approuvee_par": "Approuvée par {{nom}} (décision {{id}})",
  "v4.documents2.rediger.choisir_amont": "Document amont",
  "v4.documents2.rediger.choisir_production": "Choisir une production",
  "v4.documents2.rediger.choisir_source": "Choisir une source",
  "v4.documents2.rediger.consignes": "Consignes (facultatif)",
  "v4.documents2.rediger.consignes_non_transmises": "La spécification assistée ne reçoit pas de consignes : choisissez une autre production pour en transmettre.",
  "v4.documents2.rediger.creation_initiale": "Création d’un document neuf : aucun document cible requis, distincte d’une révision.",
  "v4.documents2.rediger.decisions_en_chargement": "Lecture des approbations en cours.",
  "v4.documents2.rediger.decisions_indisponibles": "Les approbations du projet n'ont pas pu être lues : réessayez.",
  "v4.documents2.rediger.document_amont_non_approuve": "La version choisie n’est pas approuvée.",
  "v4.documents2.rediger.echec": "La demande a échoué.",
  "v4.documents2.rediger.empreinte": "Empreinte",
  "v4.documents2.rediger.lancee": "Rédaction lancée.",
  "v4.documents2.rediger.lancer_production": "Lancer la production",
  "v4.documents2.rediger.option_amont": "{{titre}} — version {{n}}",
  "v4.documents2.rediger.preparer_amont": "Préparer un document amont",
  "v4.documents2.rediger.production": "Production à rédiger",
  "v4.documents2.rediger.production_lancee": "Production lancée.",
  "v4.documents2.rediger.provenance": "Provenance",
  "v4.documents2.rediger.rediger_specification": "Rédiger la spécification",
  "v4.documents2.rediger.selection_amont_requise": "Choisissez d’abord un document amont.",
  "v4.documents2.rediger.source": "Source de la production",
  "v4.documents2.rediger.source_requise": "Choisissez une source approuvée.",
  "v4.documents2.rediger.sources_admissibles": "Sources admissibles : versions approuvées du projet.",
  "v4.documents2.rediger.suivre": "Suivre dans les décisions",
  "v4.documents2.rediger.titre": "Rédiger un premier document",
  "v4.documents2.rediger.titre_amont": "Titre",
  "v4.documents2.rediger.version_amont": "Version",
  "v4.documents2.rediger.vide_amont": "Aucun document amont approuvé dans ce projet.",
  "v4.documents2.repere.atteint": "Atteint",
  "v4.documents2.repere.avancement": "Avancement",
  "v4.documents2.repere.avancement_element": "Avancement : {{avancement}}",
  "v4.documents2.repere.classement": "Classement du projet",
  "v4.documents2.repere.date_cible": "Date cible",
  "v4.documents2.repere.elements": "Éléments contributeurs",
  "v4.documents2.repere.en_cours": "En cours",
  "v4.documents2.repere.en_retard": "En retard",
  "v4.documents2.repere.preuves": "Preuves : {{n}}",
  "v4.documents2.repere.quoi": "le repère",
  "v4.documents2.repere.retour": "Retour à la feuille de route",
  "v4.documents2.repere.sans_version": "Aucune version liée",
  "v4.documents2.repere.situation": "Situation",
  "v4.documents2.repere.source": "Repère « {{cle}} » défini par la planification du modèle figé.",
  "v4.documents2.repere.titre": "Repère de la feuille de route",
  "v4.documents2.repere.version": "Version {{version}}",
  "v4.documents2.repere.vide_elements": "Aucun élément ne contribue à ce repère.",
  "v4.documents2.revision.acceptee": "Révision acceptée.",
  "v4.documents2.revision.accepter": "Accepter la révision",
  "v4.documents2.revision.cas": "Cas de test reliés : {{n}}",
  "v4.documents2.revision.confirmer_retrait": "Je confirme le retrait de ma révision",
  "v4.documents2.revision.criteres": "Critères touchés : {{n}}",
  "v4.documents2.revision.decideur": "Décidée par",
  "v4.documents2.revision.decision": "Décision",
  "v4.documents2.revision.decision_echec": "La décision a échoué.",
  "v4.documents2.revision.deja_decidee": "Cette révision est déjà décidée.",
  "v4.documents2.revision.demandeur": "Demandeur",
  "v4.documents2.revision.document_vise": "Ouvrir le document visé",
  "v4.documents2.revision.elements": "Éléments issus : {{n}}",
  "v4.documents2.revision.etat": "État",
  "v4.documents2.revision.etat_acceptee": "Acceptée",
  "v4.documents2.revision.etat_ouverte": "Ouverte",
  "v4.documents2.revision.etat_realisee": "Réalisée",
  "v4.documents2.revision.etat_refusee": "Refusée",
  "v4.documents2.revision.etat_retiree": "Retirée",
  "v4.documents2.revision.etat_toutes": "Toutes",
  "v4.documents2.revision.impact_calcule": "Impact calculé",
  "v4.documents2.revision.impact_estime": "Impact estimé",
  "v4.documents2.revision.impact_incomplet": "Impact incomplet : certaines liaisons n’ont pas pu être relues.",
  "v4.documents2.revision.impact_major": "Majeur",
  "v4.documents2.revision.impact_minor": "Mineur",
  "v4.documents2.revision.justification": "Justification",
  "v4.documents2.revision.note": "Note de décision",
  "v4.documents2.revision.note_aide": "Obligatoire pour refuser.",
  "v4.documents2.revision.note_obligatoire": "Une note est obligatoire pour refuser.",
  "v4.documents2.revision.quoi": "la révision",
  "v4.documents2.revision.refusee": "Révision refusée.",
  "v4.documents2.revision.refuser": "Refuser la révision",
  "v4.documents2.revision.retiree": "Révision retirée.",
  "v4.documents2.revision.retirer": "Retirer la révision",
  "v4.documents2.revision.retour": "Retour à la rédaction",
  "v4.documents2.revision.retrait_distinct": "Le retrait par le demandeur et le refus par un validateur sont deux événements distincts.",
  "v4.documents2.revision.retrait_echec": "Le retrait a échoué.",
  "v4.documents2.revision.titre": "Proposition de révision",
  "v4.documents2.revision.version_visee": "Version visée",
  "v4.documents2.revision.versions_attente": "Versions en attente : {{n}}",
  "v4.documents2.sans_projet": "Choisissez d’abord un projet.",
  "v4.documents2.version": "version {{n}}"
}
